class OrderItemList extends HTMLElement {
  constructor() {
    super();
    this.item = document.querySelector('order-item').cloneNode(true);
  }

  /**
   * Renders the list of the items in the order grouped by the shipping package
   * @param {*} order 
   */
  renderOrderItems(order) {
    const {
      getOrderStatus,
      getYPackageStatus,
    } = ORDER_UTILS;

    const orderItems = order.orderItems;

    const groupedByShipment = orderItems.reduce(
      (memo, orderItem) => {
        const trackingNumber = orderItem.yPackage?.trackingNumber || '';
        let itemsForTrackingNumber = memo.get(trackingNumber);
        if (!itemsForTrackingNumber) {
          itemsForTrackingNumber = [];
          memo.set(trackingNumber, itemsForTrackingNumber);
        }
        itemsForTrackingNumber.push(orderItem);
        return memo;
      },
      new Map(),
    );
    const orderItemsByShipment = [...groupedByShipment.values()];

    const orderItemsContainer = this.querySelector('.order-items-container');
    const orderItemsByShipmentElements = [];

    if (orderItemsByShipment.length === 1) {
      const statusElement = this.buildStatusElement('order', getOrderStatus(order));
      orderItemsByShipmentElements.push(statusElement);

      if (orderItems[0].yPackage) {
        const trackingElement = this.buildTrackingElement(orderItems[0].yPackage)
        orderItemsByShipmentElements.push(trackingElement);
      }
    }

    orderItemsByShipment.forEach((items, index) => {
      const itemsContainer = document.createElement('div');
      itemsContainer.classList.add('order-items-delivery-container');
      
      if (orderItemsByShipment.length > 1) {
        const shipmentHeader = document.createElement('h3');

        shipmentHeader.textContent = ORDER_STATUS_CONFIG.deliveryNOfTotalText
          .replace('[n]', index + 1)
          .replace('[total]', orderItemsByShipment.length);
        itemsContainer.appendChild(shipmentHeader);

        const statusElement = this.buildStatusElement('package', getYPackageStatus(items[0].yPackage));
        itemsContainer.appendChild(statusElement);
  
        if (items[0].yPackage) {
          const trackingElement = this.buildTrackingElement(items[0].yPackage)
          itemsContainer.appendChild(trackingElement);
        }
      }

      const orderItemEls = items.map((item) => {
        const orderItem = this.querySelector('order-item').cloneNode(true);
        orderItem.innerHTML = this.item.innerHTML
        orderItem.renderItem(item);
        return orderItem;
      });

      itemsContainer.append(...orderItemEls);
      orderItemsByShipmentElements.push(itemsContainer);
    });

    orderItemsContainer.replaceChildren(...orderItemsByShipmentElements);
  }

  buildTrackingElement({ carrier, trackingNumber }) {
    const carrierUrl = getCarrierUrl({ carrier, trackingNumber });
    const trackingElDiv = document.createElement('div');
    trackingElDiv.classList.add('tracking-container');
    const trackingElText = document.createElement('span');
    trackingElText.textContent = `${ORDER_STATUS_CONFIG.trackingNumberLabel}: `;
    const trackingElLink = document.createElement('a');
    trackingElLink.target = '_blank';
    trackingElLink.href = carrierUrl;
    trackingElLink.textContent = trackingNumber;

    trackingElDiv.appendChild(trackingElText);
    trackingElDiv.appendChild(trackingElLink);

    return trackingElDiv;
  }

  buildStatusElement(labelType, status) {
    const statusLabel = ORDER_STATUS_CONFIG.statusLabels[labelType][status];

    const statusElDiv = document.createElement('div');
    const statusElText = document.createElement('span');
    statusElText.textContent = `${ORDER_STATUS_CONFIG.statusText}: ${statusLabel}`;
    statusElDiv.appendChild(statusElText);

    return statusElDiv;
  }
}

customElements.define('order-item-list', OrderItemList);
